<template>
  <Modal :id="id" title="Request an Event">
    <div slot="body" class="modal-body p-0">
      <transition name="fade">
        <div v-if="loading" class="alert alert-info">
          <p class="m-0">Loading...</p>
        </div>
      </transition>
      <div class="event-request-calendar px-3 pt-3 pb-4">
        <div class="calendar-pagination text-center mb-3">
          <span class="prev" @click="prevMonth()">
            <icon icon="arrow-left" class="svg-icon" />
          </span>
          <h3 class="d-inline text mx-3">{{ month | moment("MMMM YYYY") }}</h3>
          <span class="next" @click="nextMonth()">
            <icon icon="arrow-right" class="svg-icon" />
          </span>
        </div>
        <Calendar
          :month="month"
          :custom-classnames="calendarDayClasses"
          @day-selected="daySelected"
        />
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <div class="alert alert-info">
        <p class="mb-0">
          Please note: This calendar displays the available START DATES for this
          course. When scheduling multi-day events, the START DATE is the only
          date you will need to select.
        </p>
      </div>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";

export default {
  mixins: [ModalMixin],

  data() {
    return {
      id: "event-request-calendar-modal",
      course: null,
      month: this.$moment().format("YYYY-MM"),
      available: [],
      messages: [],
      loading: false,
      loadingTimeout: null,
    };
  },

  computed: {
    calendarDayClasses() {
      var classnames = {};
      for (var d = 1; d <= this.lastDayOfTheMonth; d++) {
        var date = this.$moment(this.month).date(d).format("YYYY-MM-DD");
        if (!this.available.includes(date)) {
          classnames[date] = "unavailable";
        }
        if (this.messages[date] !== undefined) {
          classnames[date] = classnames[date] ? classnames[date] + " has-messages" : "has-messages";
        }
      }
      return classnames;
    },
    lastDayOfTheMonth() {
      return parseInt(this.$moment(this.month).endOf("month").format("D"), 10);
    },
  },

  watch: {
    month(val) {
      this.refresh();
    },
  },

  methods: {
    refresh: _.debounce(function () {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = setTimeout(() => (this.loading = true), 500);
      this.axios
        .get(this.route("event-request.calendar", { course: this.course.id }), {
          params: { month: this.month },
        })
        .then((response) => {
          this.available = response.data.availables;
          this.messages = response.data.messages;
          this.loading = false;
          clearTimeout(this.loadingTimeout);
        });
    }, 300),
    prevMonth() {
      var prev = this.$moment(this.month)
        .subtract(1, "months")
        .format("YYYY-MM");
      this.month = prev;
    },
    nextMonth() {
      var next = this.$moment(this.month).add(1, "months").format("YYYY-MM");
      this.month = next;
    },
    daySelected(day) {
      var date = this.$moment(this.month).date(day).format("YYYY-MM-DD");
      if (this.available.includes(date)) {
        var url = this.route("event-request.create", {
          course: this.course.id,
        });
        url += "?start_date=" + date;
        this.goToUrl(url);
      }
    },
    createPopoverContent(date) {
      if (!this.messages[date] || this.messages[date].length === 0) {
        return '';
      }

      let content = '<div class="message-popover">';
      this.messages[date].forEach(message => {
        content += `<div class="message-item">
          <strong>${message.name}</strong>
          <p>${message.content}</p>
        </div>`;
      });
      content += '</div>';

      return content;
    },
    initPopovers() {
      // Clear any existing popovers
      $('[data-toggle="popover"]').popover('dispose');

      // Initialize popovers for days with messages
      setTimeout(() => {
        $('.calendar td.has-messages').each((index, el) => {
          const day = $(el).find('.date').text();
          const date = this.$moment(this.month).date(day).format("YYYY-MM-DD");

          $(el).attr('data-toggle', 'popover');
          $(el).attr('data-html', 'true');
          $(el).attr('data-content', this.createPopoverContent(date));
          $(el).attr('data-placement', 'top');
          $(el).popover({
            trigger: 'hover',
            container: 'body'
          });
        });
      }, 100);
    },
  },

  created() {
    this.course = this.options.course;
  },

  mounted() {
    this.refresh();
  },

  updated() {
    this.initPopovers();
  }
};
</script>

<style lang="scss">
#event-request-calendar-modal {
  .modal-dialog {
    max-width: 40%;
  }

  td {
    padding: 1% 0;
  }

  .calendar td.has-messages {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      top: 5px;
      right: 5px;
      width: 10px;
      height: 10px;
      background-color: #008000;
      border-radius: 50%;
    }

    &:hover {
      cursor: pointer;
    }
  }

.alert {
  border-radius: 0;
  margin: 0;
}
.modal-body .alert {
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  position: absolute;
  height: 100%;
  width: 100%;
  padding: 0;
  z-index: 9999;
  opacity: 0.8;

  p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.modal-footer {
  border: none;
  padding: 0;
}

.message-popover {
  .message-item {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    p {
      margin-bottom: 0;
    }
  }
}
}
</style>
